import { SubmissionObject, errors as submissionErrors } from 'src/pages/submissions/script/common.data'
import { mapActions } from 'vuex'
import Misc from 'src/utils/helper/misc'
import { ceil, isEmpty } from 'lodash'
import numWords from 'num-words';

export default {
  ...mapActions('submissions', ['update', 'get', 'set', 'create']),
  ...mapActions('foundrySupport', ['getFoundryById']),

  updateSubmissionErrors(errors, customKey) {
    if (!isEmpty(errors)) {
      if (submissionErrors.value.filter(error => !Object.hasOwn(error, customKey))) {
        submissionErrors.value.push(errors)
      }
    } else {
      submissionErrors.value = submissionErrors.value.filter(error => !Object.hasOwn(error, customKey))
    }
    submissionErrors.value = [...new Set(submissionErrors.value.map(itm => JSON.stringify(itm)))].map(i =>
      JSON.parse(i)
    )
  },

  fetchErrorsOnlyRequired() {
    this.$events.$emit('get_selectedFoundry', window.localStorage.getItem('sessionFoundryId'))
    submissionErrors.value = [...new Set(submissionErrors.value.map(itm => JSON.stringify(itm)))].map(i =>
      JSON.parse(i)
    )
    let allErrors = submissionErrors.value.map(err => {
      const [errorMessage] = Object.values(err)
      return errorMessage
    })

    const required = allErrors.filter(e => e.indexOf('is required.') !== -1)
    if (required.length) {
      const combine = []
      required.forEach(item => {
        const field = item.match('The (.*) field is required')
        if ((field || [])[1]) {
          combine.push(field[1].trim())
        }
      })
      if (isEmpty(required)) {
        this.$events.$emit('trigger:preview')
      }
      return `${this.$t('pages.submissions.components.prices.errors.required_errors')}: ${combine.join(', ')}`
    }
  },
  fetchErrorsExceptRequired(step) {
    const allErrorMessage = this.step(step).errors.map(err => {
      const [errorMessage] = Object.values(err)
      return errorMessage
    })
    return allErrorMessage.filter(e => e.indexOf('is required.') === -1)
  },
  getSubmissionIdFromRoute() {
    const routeParams = (this.$route?.params) || {}
    return typeof routeParams.id === 'string' && Object.keys(routeParams).length !== 0
      ? this.$sanitize(routeParams.id)
      : null
  },
  getFormatFromRoute() {
    const routeParams = (this.$route?.params) || {}
    if (
      routeParams.hasOwnProperty('format') &&
      (typeof routeParams.format === 'number' || typeof routeParams.format === 'string')
    ) {
      const formatId = Number(routeParams.format)
      return formatId
    }
    return null
  },
  startSubmission() {
    return new Promise(resolve => {
      const routeId = this.getSubmissionIdFromRoute()
      /**
       * If id, get submission
       */
      if (routeId) {
        this.get({
          id: routeId
        })
          .then(submission => {
            if (typeof submission?.id === 'string') {
              window.localStorage.setItem('getSubmissionList', JSON.stringify(submission))
              return this.set({
                submission
              })
            } else {
              resolve()
            }
          })
          .then(resolve)
      } else {
        resolve()
      }
    })
  },
  createSubmission() {
    return new Promise(resolve => {
      this.resetSubmission()
        .then(() => {
          return this.create()
        })
        .then(submission => {
          if (submission) {
            resolve(submission)
          } else {
            resolve()
          }
        })
    })
  },
  setSkuId() {
    if (this.submission.isLive && this.submission.userMetaData.packages.length > 0) {
      const familyPack = this.submission.userMetaData.packages.filter(i => i.packageType === 'familyPackage')
      const singlePack = this.submission.userMetaData.packages.filter(i => i.packageType === 'singleStyle')
      const customPack = this.submission.userMetaData.packages.filter(i => i.packageType === 'customPackage')
      if (familyPack[0].oldSku === '0') {
        familyPack[0].oldSku = familyPack[0].skuId
      }
      familyPack[0].skuId = 0
      const submissionPackages = [...familyPack, ...singlePack, ...customPack]
      this.submission.userMetaData.packages = submissionPackages
    }
  },
  validateBnnedAndWarnWords(bannedword) {
    return (Array.isArray(bannedword) && !isEmpty(bannedword) && bannedword.every(value => value === false)) || (typeof bannedword === 'boolean' && bannedword)
  },
  updateSubmission(liveInReview = false, checkDescription = '', bannedword = false) {
    if (this.validateBnnedAndWarnWords(bannedword)) {
      return;
    }
    return new Promise(resolve => {
      const $ = this
      const buildData = () => {
        return new Promise(resolve => {
          const promises = []
          for (const build of SubmissionObject.builds) {
            promises.push(Promise.resolve(build()))
          }
          Promise.all(promises).then(resolve)
        })
      }
      buildData()
        .then(() => {
          const promises = []
          for (const refresh of SubmissionObject.refreshs) {
            promises.push(Promise.resolve(refresh()))
          }
          return Promise.all(promises)
        })
        .then(() => {
          /**
           * add timeout to API call to prevent multiple PUTs.
           */
          const submission = this.submission
          if (liveInReview) {
            submission.status = 'in_review'
          }
          SubmissionObject.updateTimer.clear()
          SubmissionObject.updateTimer.set(() => {
            $.update(submission)
              .then(response => {
                if (response.data.submission) {
                  $.$store.commit('submissions/setLiveSpinner', false)
                  $.$store.dispatch('submissions/updateStatus', response.data.submission)
                }
                resolve()
              })
              .catch(() => {
                if (submission.status === 'in_review') {
                  submission.status = 'live'
                }
                resolve()
              })
          }, $.$store.getters['settings/updateDelay'])
        })
        .catch(error => {
          // Just for now …
          resolve()
        })
    })
  },
  updateSubmissionStatus() {
    return new Promise(resolve => {
      this.get({
        id: this.submission.id,
        force: true
      })
        .then(response => {
          return this.$store.dispatch('submissions/updateStatus', response)
        })
        .then(() => {
          this.updateSubmissionSteps()
          resolve()
        })
        .catch(() => {
          resolve()
        })
    })
  },
  updateSubmissionSteps() {
    if (this.submission.progress) {
      Object.keys(this.submission.progress).forEach((section, idx) => {
        this.steps[idx].complete = this.submission.progress[section] === 'complete'
        if (!this.steps[idx].complete) {
          this.steps[idx].valid = false
        } else {
          this.steps[idx].valid = true
        }
      })
    }
  },
  resetSubmission() {
    return new Promise(resolve => {
      this.$store
        .dispatch('submissions/reset')
        .then(() => {
          this.$store.commit('binaries/clear')
          this.$store.commit('binaries/emptyNewBinaries')
          this.$store.commit('designers/clear')
          this.$store.commit('graphics/clear')
          this.$store.commit('tags/clear')
          SubmissionObject.reset()
        })
        .then(resolve)
    })
  },
  setSubmissionBuild(options) {
    if (typeof options.before === 'function') {
      SubmissionObject.builds.push(options.before)
    }
    if (typeof options.after === 'function') {
      SubmissionObject.refreshs.push(options.after)
    }
  },
  resetSubmissionObjectBuilds() {
    SubmissionObject.builds = []
  },
  addReadyState() {
    /**
     * This is for init loading.
     * Add this.ready to your submission component.
     * Should look like: { name: this.$options.name, state: 'unset' }
     * Then add addReadyState() in created().
     * The idea is to toggle the state from 'unset' to 'set' when component is ready after init.
     * So submission page will visible when all states are 'set'. See isAllReady() above.
     */
    if (this.ready) {
      if (!SubmissionObject.readyStates.some(r => r.name === this.ready.name)) {
        SubmissionObject.readyStates.push(this.ready)
        return true
      }
    }
  },
  getReadyStates() {
    return SubmissionObject.readyStates
  },
  resetReadyStates() {
    SubmissionObject.readyStates = []
  },
  isAllReadyStatesComplete() {
    const someUnset = SubmissionObject.readyStates.some(ready => ready.state === 'unset')
    /**
     * isAllReadyStatesComplete() is used for v-show, so fou-expand needs to be refreshed, when it become visible.
     * So style calculations can be made.
     */
    if (!SubmissionObject.readyComplete && !someUnset) {
      SubmissionObject.readyComplete = true
      this.$events.$emit('fou:expand:update')
    }
    return SubmissionObject.readyComplete
  },
  isReadyStateComplete() {
    return this.ready.state === 'set'
  },
  getRegularStyleId() {
    return this.submission?.userMetaData?.defaultLayoutFont?.id
  },
  setDefaultUser() {
    this.user = this.$store.getters['auth/user']
    this.submission.owner = { displayName: this.user.displayName, email: this.user.name, userId: this.user.userId }
  },
  getFoundryForSubmission() {
    this.getFoundryById({ foundryId: this.submission?.foundry?.foundryId }).then(resp => {
      //Add checks for foundry support in next iteration
    })
  },
  getSubmissionBiranyIndex() {
    return id => {
      return this.submissionBinaries
        .map(b => {
          return b.binaryId
        })
        .indexOf(id)
    }
  },
  isSet() {
    return this.$store.getters['binaries/hasSomeMeta']
  },
  isEmptyBinaryList() {
    return this.$store.getters['binaries/list'].length === 0
  },
  resetSubmissionStore() {
    return new Promise(resolve => {
      this.$store
        .dispatch('submissions/reset')
        .then(() => {
          this.$store.commit('binaries/clear')
          this.$store.commit('binaries/emptyNewBinaries')
          this.$store.commit('designers/clear')
          this.$store.commit('graphics/clear')
          this.$store.commit('tags/clear')
          this.resetSubmissionFormat()
        })
        .then(resolve)
    })
  },
  checkUniqueStyle() {
    if (this.submission.isLive) {
      this.uniqueStyleErrors = []
      let errorStyles = []
      const oldFonts = this.externalDataSource
        ? [...this.submission.userMetaData.pimBinaries]
        : [...this.submission.userMetaData.myFontsbinaries]
      const newFonts = this.submissionBinaries.filter(val => {
        return !val.hasOwnProperty('uniqueName') && val.hasOwnProperty('status') && val.status === 'new'
      })
      oldFonts.forEach(val => {
        const errorFonts = newFonts.filter(data => {
          const newFontUniqueName = Misc.strToLowerCase(Misc.dashedString(data.styleName).replace(/[,/\\]/g, ''));
          return newFontUniqueName === val.uniqueName
        })
        errorStyles = Misc.removeDuplicates([...errorStyles, ...errorFonts], true)
      })
      errorStyles.forEach(data => {
        const obj = { styleId: data.binaryId, styleName: data.styleName }
        this.uniqueStyleErrors.push(obj)
      })
    }
  },
  resetSubmissionFormat() {
    this.$store.commit('submissions/resetFormat')
  },
  openErrorSection() {
    const stepNames = []
    for (const step of this.steps) {
      step.open = false
      if (step.anyErrors() || !step.valid) {
        stepNames.push(step.name)
      }
    }
    const index = Misc.findIndex(this.steps, { name: stepNames[0] })
    this.steps[index].open = true
  },
  isCustomerMsg(fontData) {
    if (fontData.hasOwnProperty('items')) {
      return fontData.items.some(binary => binary.hasOwnProperty('status') && binary.status === 'updated')
    }
  },
  submissionValidationUtility() {
    this.validateAll().then(() => {
      if (!this.isAllValid()) {
        this.openErrorSection()
      }
    })
  },
  onLoadValidate() {
    let events = []
    this.$events?.$on('on_load_validate_sections', section => {
      events.push(section)
      if (!isEmpty(this.submission)) {
        // isNewSubmsn to check if submission is New or not
        const isNewSubmsn = Object.values(this.submission?.progress).every(item => item === 'empty')
        // events array length is 4 when no binaries are there as no designers API call
        const evtL4 = this.submissionBinaries.length === 0 && events.length === 4
        // events array length is 4 when binaries are there
        const evtL5 = this.submissionBinaries.length > 0 && events.length === 4
        const validEvt = events.every(e => e !== undefined)
        if (!isNewSubmsn) {
          if (evtL4 && validEvt) {
            this.submissionValidationUtility()
            events = []
          }
          if (evtL5 && validEvt && !this.submissionLimitError) {
            this.submissionValidationUtility()
          }
        } else {
          events = []
        }
      }
    })
  },
  checkUniqueMD5(binaryCollection) {
    if (this.submission.isLive) {
      this.uniqueMD5Errors = []
      let errorMD5 = []
      const oldFonts = this.externalDataSource
        ? [...this.submission.userMetaData.pimBinaries]
        : [...this.submission.userMetaData.myFontsbinaries]
      const newFonts = this.submissionBinaries.filter(val => {
        return !val.hasOwnProperty('uniqueName') && val.hasOwnProperty('status') && val.status === 'new'
      })
      const newMD5Fonts = newFonts.map(val => {
        const bin = Misc.findSpecificObject(binaryCollection, { id: val.binaryId })
        val.md5Checksum = bin ? bin.md5Checksum : 'n/a'
        return val
      })
      oldFonts.forEach(val => {
        const errorFonts = newMD5Fonts.filter(data => val.md5Checksum === data.md5Checksum)
        errorMD5 = Misc.removeDuplicates([...errorMD5, ...errorFonts], true)
      })
      errorMD5.forEach(data => {
        const obj = { styleId: data.binaryId, styleName: data.styleName }
        this.uniqueMD5Errors.push(obj)
      })
    }
  },
  navigateToSubmissionSuccess(scopeThis = this, status = '') {
    const obj = {
      familyName: String(scopeThis.submissionFamilyName),
      isFamilyLive: status === 'live'
    }
    scopeThis.$store.commit('submissions/setIsSuccess', obj)
    scopeThis.$router.replace({ name: 'success_submission' })
  },
  handleCustomPackageValidation(isShowPopup = '') {
    const totalFontFiles = this.submission?.userMetaData?.packages?.filter(item => item.packageType === 'singleStyle').length;
    if (totalFontFiles) {
      const allowedCustomPackage = ceil(totalFontFiles / 4)
      const initialPackageLength = this.getInitialSubmissionPackage.filter(item => item.packageType == 'customPackage').length
      const customPackageArray = this.submissionPackages.filter(item => item.packageType == 'customPackage')
      let submissionStatus = this.submission.status
      const availableCustomPackage = customPackageArray.length
      if (initialPackageLength >= availableCustomPackage && submissionStatus !== 'in_work') {
        submissionErrors.value = submissionErrors.value.filter(error => !Object.hasOwn(error, 'customPackage validation prices'))
      } else if (availableCustomPackage > allowedCustomPackage) {
        const validCustomPackageLength = availableCustomPackage - allowedCustomPackage
        this.$store.commit('submissions/setCountFontFiles', numWords(totalFontFiles).charAt(0).toUpperCase() + numWords(totalFontFiles).substring(1))
        this.$store.commit('submissions/setValidCustomPackageLength', numWords(validCustomPackageLength))
        this.$store.commit('submissions/setAllowedCustomPackageLength', numWords(allowedCustomPackage))
        if (isShowPopup) {
          this.$store.commit('submissions/setCustomPackageModal', true)
        }
        const errorMessage = this.$t('pages.submissions.components.upload.results.customPackageModal.desc', {
          countDeletePackage: numWords(validCustomPackageLength),
          allowedCustomPackageLength: numWords(allowedCustomPackage),
          countFontFiles: numWords(totalFontFiles).charAt(0).toUpperCase() + numWords(totalFontFiles).substring(1)
        })
        submissionErrors.value.push({ 'customPackage validation prices': errorMessage })
      } else {
        submissionErrors.value = submissionErrors.value.filter(error => !Object.hasOwn(error, 'customPackage validation prices'))
      }
    }
  },
  closeCustomPackagePopupModal() {
    this.$store.commit('submissions/setCustomPackageModal', false)
    this.hide()
  }
}
